<template>
    <div>
        <v-row>
            <v-col class="col-1">
                <v-btn fab dark color="primary" @click="add()">
                    <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </v-col>

            <v-col class="col-4 offset-7">
                <form v-on:submit.prevent="getFromApi()">
                    <v-text-field
                            class="pa-0"
                            v-model="filters.quickSearch"
                            outlined
                            autocomplete="off"
                            label="Quick search"
                            placeholder="nome"
                            :append-icon="'mdi-magnify'"
                            hint="nome"
                            dense
                    ></v-text-field>
                </form>
            </v-col>
        </v-row>

        <v-data-table
                :headers="headers"
                :items="items"
                item-key="id"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                :loading="loading"
                loading-text="Carregando..."
                no-data-text="Nenhum registro encontrado"
                dense
                show-current-page="true"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  'items-per-page-options': [5, 10, 30, 70, 100],
                }"
                :items-per-page="30"
        >
            <template v-slot:item.actions=" { item }
        ">
                <v-btn
                        @click="editItem(item)"
                        icon
                >
                    <v-icon
                            small
                            class="mr-2"
                            color="primary"
                    >
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-icon
                        small
                        @click="deleteItem(item)"
                        color="error"
                >
                    mdi-delete
                </v-icon>
            </template>

            <template v-slot:item.created_at="{ item }">
                {{item.created_at | moment('DD/MM/YYYY HH:mm')}}
            </template>

            <template v-slot:item.updated_at="{ item }">
                <span>{{item.updated_at | moment('DD/MM/YYYY HH:mm')}}</span>
            </template>

        </v-data-table>

        <!--        <template v-slot:top>-->
        <!--            <v-toolbar flat>-->
        <v-dialog
                v-model="alertDialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class="orange--text">Atenção</span>
                </v-card-title>

                <v-card-text>
                    {{alertDialogText}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary darken-1"
                            text
                            @click="alertDialog = false"
                    >
                        Ok, entendi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--            </v-toolbar>-->
        <!--        </template>-->

    </div>


</template>

<script>
    export default {
        data: () => ({
            endpoint: 'timelines',
            items: [],
            totalItems: 0,
            options: {},
            dialog: false,
            alertDialog: false,
            alertDialogText: "",
            filters: {
                departamento: '',
                quickSearch: '',
            },

            // btn loading
            loader: null,
            loading: false,

            //select de departamentos
            departamentos: [{text: '', value: ''}],

            headers: [
                {
                    text: 'Ações',
                    value: 'actions',
                    sortable: false,
                    width: '10%',
                },
                {
                    text: 'Nome',
                    sortable: true,
                    value: 'nome'
                },
                {
                    text: 'Criado em',
                    sortable: true,
                    value: 'created_at'
                },
                {
                    text: 'Atualizado em',
                    sortable: true,
                    value: 'updated_at'
                },
                // {
                //     text: 'Departamento',
                //     sortable: true,
                //     value: 'departamento_descricao'
                // },
            ],
            editedIndex: -1,
            editedItem: {
                codigo: '',
                descricao: '',
            },
            defaultItem: {
                codigo: '',
                descricao: '',
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Item' : 'Edição do Item'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            options: {
                handler() {
                    this.getFromApi();
                },
                deep: true,
            }

        },

        methods: {
            add() {
                this.$store.commit('resetTimelineState');
                this.$router.push({path: '/timeline/0/edit'});
            },

            getFromApi() {
                this.loading = true;

                const {sortBy, sortDesc, page, itemsPerPage} = this.options;

                let params = {
                    filters: this.filters,
                    sortBy: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    itemsPerPage: itemsPerPage,
                };

                axios.get(this.$store.getters.getUsrEndpoint + '/' + this.endpoint, {params: params})
                    .then((response) => {
                            this.items = response.data.items;
                            this.totalItems = response.data.totalItems;

                            this.loading = false;
                        }, (error) => {
                            console.log(error);
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => this.loading = false)
                ;
            },

            editItem(item) {
                this.$router.push({path: '/timeline/' + item.id + '/edit'})
            },

            deleteItem(item) {
                const index = this.items.indexOf(item)
                if (confirm('Tem certeza que quer remover este item?')) {
                    axios
                        .delete('/' + this.endpoint + '/' + item.id)
                        .then((response) => {
                                this.dialog = false

                                // this.items.splice(index, 1);
                                // this.totalItems = this.totalItems - 1;
                                this.getFromApi();

                            }, (error) => {
                                this.alertDialog = true;
                                // if (error.response.status == 409) {
                                // }
                                this.alertDialogText = "Houve um problema ao remover o registro";
                            }
                        )
                        .catch(error => {
                            console.log(error)
                            // this.errored = true
                        })
                        .finally(() => {
                            this.loading = false;
                            this.loader = null;
                        })
                    ;
                }
            },

        },
    }
</script>
